import { ActionIcon, Button, Stack, Text, ThemeIcon, Title } from "@mantine/core";
import { ContextModalProps } from "@mantine/modals";
import { IconAlertTriangle, IconX } from "@tabler/icons-react";
import { useState } from "react";

import {
	ACCOUNT_ACCESS_ISSUE_BODY_PARAGRAPHS,
	ACCOUNT_ACCESS_ISSUE_PLAY_LABEL,
	ACCOUNT_ACCESS_ISSUE_TITLE,
	type AccountAccessIssueModalInnerProps
} from "./AccountAccessIssueModal.model";

/** Показывает объяснение проблемы ASID и предлагает продолжить с новым аккаунтом. */
export const AccountAccessIssueModal = ({
	innerProps
}: ContextModalProps<AccountAccessIssueModalInnerProps>) => {
	const [loading, setLoading] = useState(false);

	/** Запускает повторную аутентификацию и блокирует элементы окна. */
	const play = async () => {
		if (loading) return;
		setLoading(true);
		try {
			await innerProps.onPlay();
		} catch {
			// Ошибка уже передана promise-контроллером в основной обработчик авторизации.
		}
	};

	/** Закрывает окно, если повторная аутентификация ещё не запущена. */
	const requestClose = () => {
		if (!loading) {
			innerProps.onRequestClose();
		}
	};

	return (
		<Stack align="center" gap="md" style={{ position: "relative" }}>
			<ActionIcon
				aria-label="Close"
				color="gray"
				disabled={loading}
				onClick={requestClose}
				style={{ position: "absolute", right: 0, top: 0 }}
				variant="subtle"
			>
				<IconX aria-hidden />
			</ActionIcon>
			<Title order={3} ta="center">
				{ACCOUNT_ACCESS_ISSUE_TITLE}
			</Title>
			<ThemeIcon color="yellow" variant="light" radius="xl" size={56}>
				<IconAlertTriangle size={30} aria-hidden />
			</ThemeIcon>
			{ACCOUNT_ACCESS_ISSUE_BODY_PARAGRAPHS.map((paragraph) => (
				<Text key={paragraph} ta="center">
					{paragraph}
				</Text>
			))}
			<Button fullWidth loading={loading} disabled={loading} onClick={() => void play()}>
				{ACCOUNT_ACCESS_ISSUE_PLAY_LABEL}
			</Button>
		</Stack>
	);
};
